export const FETCH_BUSINESSES_REQUEST = 'businesses/FETCH_BUSINESSES_REQUEST'
export const FETCH_BUSINESSES_SUCCESS = 'businesses/FETCH_BUSINESSES_SUCCESS'
export const FETCH_BUSINESSES_FAILURE = 'businesses/FETCH_BUSINESSES_FAILURE'

export const FETCH_BUSINESS_DETAILS_REQUEST =
  'businesses/FETCH_BUSINESS_DETAILS_REQUEST'
export const FETCH_BUSINESS_DETAILS_SUCCESS =
  'businesses/FETCH_BUSINESS_DETAILS_SUCCESS'
export const FETCH_BUSINESS_DETAILS_FAILURE =
  'businesses/FETCH_BUSINESS_DETAILS_FAILURE'

export const UPDATE_BUSINESS_REQUEST = 'businesses/UPDATE_BUSINESS_REQUEST'
export const UPDATE_BUSINESS_SUCCESS = 'businesses/UPDATE_BUSINESS_SUCCESS'
export const UPDATE_BUSINESS_FAILURE = 'businesses/UPDATE_BUSINESS_FAILURE'

export const CREATE_BUSINESS_REQUEST = 'businesses/CREATE_BUSINESS_REQUEST'
export const CREATE_BUSINESS_SUCCESS = 'businesses/CREATE_BUSINESS_SUCCESS'
export const CREATE_BUSINESS_FAILURE = 'businesses/CREATE_BUSINESS_FAILURE'

export const ARCHIVE_BUSINESS_REQUEST = 'businesses/ARCHIVE_BUSINESS_REQUEST'
export const ARCHIVE_BUSINESS_SUCCESS = 'businesses/ARCHIVE_BUSINESS_SUCCESS'
export const ARCHIVE_BUSINESS_FAILURE = 'businesses/ARCHIVE_BUSINESS_FAILURE'

export const FETCH_PROPERTY_BUILDING_REQUEST =
  'businesses/FETCH_PROPERTY_BUILDING_REQUEST'
export const FETCH_PROPERTY_BUILDING_SUCCESS =
  'businesses/FETCH_PROPERTY_BUILDING_SUCCESS'
export const FETCH_PROPERTY_BUILDING_FAILURE =
  'businesses/FETCH_PROPERTY_BUILDING_FAILURE'

export const FETCH_BUSINESS_PAYMENTS_REQUEST =
  'businesses/FETCH_BUSINESS_PAYMENTS_REQUEST'
export const FETCH_BUSINESS_PAYMENTS_SUCCESS =
  'businesses/FETCH_BUSINESS_PAYMENTS_SUCCESS'
export const FETCH_BUSINESS_PAYMENTS_FAILURE =
  'businesses/FETCH_BUSINESS_PAYMENTS_FAILURE'

export const FETCH_BUSINESS_DOCUMENTS_REQUEST =
  'businesses/FETCH_BUSINESS_DOCUMENTS_REQUEST'
export const FETCH_BUSINESS_DOCUMENTS_SUCCESS =
  'businesses/FETCH_BUSINESS_DOCUMENTS_SUCCESS'
export const FETCH_BUSINESS_DOCUMENTS_FAILURE =
  'businesses/FETCH_BUSINESS_DOCUMENTS_FAILURE'

export const DOWNLOAD_BUSINESS_DOCUMENT_REQUEST =
  'businesses/DOWNLOAD_BUSINESS_DOCUMENT_REQUEST'
export const DOWNLOAD_BUSINESS_DOCUMENT_SUCCESS =
  'businesses/DOWNLOAD_BUSINESS_DOCUMENT_SUCCESS'
export const DOWNLOAD_BUSINESS_DOCUMENT_FAILURE =
  'businesses/DOWNLOAD_BUSINESS_DOCUMENT_FAILURE'

export const GENERATE_BUSINESS_DOCUMENT_REQUEST =
  'businesses/GENERATE_BUSINESS_DOCUMENT_REQUEST'
export const GENERATE_BUSINESS_DOCUMENT_SUCCESS =
  'businesses/GENERATE_BUSINESS_DOCUMENT_SUCCESS'
export const GENERATE_BUSINESS_DOCUMENT_FAILURE =
  'businesses/GENERATE_BUSINESS_DOCUMENT_FAILURE'

export const DELETE_BUSINESS_DOCUMENT_REQUEST =
  'businesses/DELETE_BUSINESS_DOCUMENT_REQUEST'
export const DELETE_BUSINESS_DOCUMENT_SUCCESS =
  'businesses/DELETE_BUSINESS_DOCUMENT_SUCCESS'
export const DELETE_BUSINESS_DOCUMENT_FAILURE =
  'businesses/DELETE_BUSINESS_DOCUMENT_FAILURE'

export const CREATE_BUSINESS_PAYMENT_REQUEST =
  'businesses/CREATE_BUSINESS_PAYMENT_REQUEST'
export const CREATE_BUSINESS_PAYMENT_SUCCESS =
  'businesses/CREATE_BUSINESS_PAYMENT_SUCCESS'
export const CREATE_BUSINESS_PAYMENT_FAILURE =
  'businesses/CREATE_BUSINESS_PAYMENT_FAILURE'

export const UPDATE_BUSINESS_PAYMENT_REQUEST =
  'businesses/UPDATE_BUSINESS_PAYMENT_REQUEST'
export const UPDATE_BUSINESS_PAYMENT_SUCCESS =
  'businesses/UPDATE_BUSINESS_PAYMENT_SUCCESS'
export const UPDATE_BUSINESS_PAYMENT_FAILURE =
  'businesses/UPDATE_BUSINESS_PAYMENT_FAILURE'

export const DELETE_BUSINESS_PAYMENT_REQUEST =
  'businesses/DELETE_BUSINESS_PAYMENT_REQUEST'
export const DELETE_BUSINESS_PAYMENT_SUCCESS =
  'businesses/DELETE_BUSINESS_PAYMENT_SUCCESS'
export const DELETE_BUSINESS_PAYMENT_FAILURE =
  'businesses/DELETE_BUSINESS_PAYMENT_FAILURE'

export const DOWNLOAD_BUSINESS_PAYMENT_REQUEST =
  'businesses/DOWNLOAD_BUSINESS_PAYMENT_REQUEST'
export const DOWNLOAD_BUSINESS_PAYMENT_SUCCESS =
  'businesses/DOWNLOAD_BUSINESS_PAYMENT_SUCCESS'
export const DOWNLOAD_BUSINESS_PAYMENT_FAILURE =
  'businesses/DOWNLOAD_BUSINESS_PAYMENT_FAILURE'

export const UPLOAD_BUSINESS_IMAGE_REQUEST =
  'businesses/UPLOAD_BUSINESS_IMAGE_REQUEST'
export const UPLOAD_BUSINESS_IMAGE_SUCCESS =
  'businesses/UPLOAD_BUSINESS_IMAGE_SUCCESS'
export const UPLOAD_BUSINESS_IMAGE_FAILURE =
  'businesses/UPLOAD_BUSINESS_IMAGE_FAILURE'

export const DELETE_BUSINESS_IMAGE_REQUEST =
  'businesses/DELETE_BUSINESS_IMAGE_REQUEST'
export const DELETE_BUSINESS_IMAGE_SUCCESS =
  'businesses/DELETE_BUSINESS_IMAGE_SUCCESS'
export const DELETE_BUSINESS_IMAGE_FAILURE =
  'businesses/DELETE_BUSINESS_IMAGE_FAILURE'

export const UPLOAD_DOCUMENT_REQUEST = 'businesses/UPLOAD_DOCUMENT_REQUEST'
export const UPLOAD_DOCUMENT_SUCCESS = 'businesses/UPLOAD_DOCUMENT_SUCCESS'
export const UPLOAD_DOCUMENT_FAILURE = 'businesses/UPLOAD_DOCUMENT_FAILURE'

export const DELETE_DOCUMENT_REQUEST = 'businesses/DELETE_DOCUMENT_REQUEST'
export const DELETE_DOCUMENT_SUCCESS = 'businesses/DELETE_DOCUMENT_SUCCESS'
export const DELETE_DOCUMENT_FAILURE = 'businesses/DELETE_DOCUMENT_FAILURE'

export const UPDATE_FIELD = 'businesses/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'businesses/SET_DEFAULT_DATA'
